import styled from '@emotion/styled';

import { Table as BaseTable, TableRow as BaseTableRow } from 'components';

export const Table = styled(BaseTable)`
  th:first-of-type {
    width: 70%;
  }
`;

export const TableRow = styled(BaseTableRow)`
  td:last-child {
    padding-right: ${({ isRemovable }) => (isRemovable ? '0' : '1.42rem')};
    position: relative;
  }
`;

export const Exception = styled.span`
  color: ${({ theme }) => theme.colors.secondary};
`;

export const ItemTitle = styled.span`
  color: ${({ theme, color }) => theme.colors[color || 'item']};
`;
export const ItemDescription = styled.span`
  color: ${({ theme, color }) => theme.colors[color || 'item']};
  padding-left: 4.3rem;
`;

export const IconsWrapper = styled.span`
  position: absolute;
  display: flex;
  align-items: center;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);

  svg {
    width: 1.8rem;
    font-size: 1.8rem;
    cursor: pointer;
    margin: 0 0 0.2rem 1.4rem;
    opacity: 0.6;
    color: ${({ theme }) => theme.colors.action};
    stroke: ${({ theme }) => theme.colors.action};

    &:hover {
      opacity: 0.9;
    }

    &.disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }
`;

export const ItemDetailTable = styled(BaseTable)`
  width: 100%;
  td {
    padding: 0 0 8px 0 !important;
    &:first-child {
      width: 200px;
      text-align: left;
      vertical-align: top;
    }
  }
`;
